"use client";
import React, { useState } from "react";
import "./HomeHero.scss";
import { Container, Row, Col } from "react-bootstrap";
import ContactModal from "../ContactModal/ContactModal";

const HomeVideo = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  return (
        <div className="hero-wrapper">
          <Container >
            <div className="inner-header flex"></div>
            <div>
              <svg
                className="waves"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 24 150 28"
                preserveAspectRatio="none"
                shapeRendering="auto"
              >
                <defs>
                  <path
                    id="gentle-wave"
                    d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                  />
                </defs>
                <g className="parallax">
                  <use href="#gentle-wave" x="48" y="0" fill="#53a2a7" />
                  <use href="#gentle-wave" x="48" y="2" fill="#317f84" />
                  <use href="#gentle-wave" x="48" y="5" fill="#196064" />
                  <use href="#gentle-wave" x="48" y="7" fill="#134b4e" />
                </g>
              </svg>
            </div>

            <Row className="hero-section onboarding-section">
              <Col md={6} className="hero-text-container primary">
                  <h1 className="klean-leaf-title">Klean Leaf</h1>
                  <p className="klean-leaf-title">Private Label Laundry Detergent Sheets Manufacturer</p>
                  <h4>We help brands develop, customize, package, and ship laundry detergent sheets with flexible MOQ, fragrance options, and private label support.</h4>
              </Col>

              <Col md={6} className="hero-text-container hero-metrics primary">
                <div className="metrics-row">
                  <div className="metric-item">
                    <h3>300+</h3>
                    <p>Clients</p>
                  </div>
                  <div className="split-line"></div>
                  <div className="metric-item">
                    <h3>12+</h3>
                    <p>Years</p>
                  </div>
                  <div className="split-line"></div>
                  <div className="metric-item">
                    <h3>100%</h3>
                    <p>Plastic-Free</p>
                  </div>
                </div>
                <div className="samples-button">
                  <button className="primary-btn get-sample" type="primary" onClick={showModal}>
                    Get your Free Samples
                  </button>
                </div>
              </Col>

              <ContactModal isModalOpen={isModalOpen} handleCancel={handleCancel} />


            </Row>


          </Container>
        </div>
        
        
  );
};

export default HomeVideo;
